const calculate = {
  calculate: {
    title: "Calculate for Others",
    subtitle: "Generate Purple Star Astrology charts for friends, family, or clients",
    savedProfiles: "Saved Profiles",
    noProfiles: "No saved profiles yet",
    newCalculation: "New Calculation",
    enterDetails: "Enter the person's details to generate their Purple Star Astrology chart",
    generateChart: "Generate Chart",
    aboutZiWei: "About Purple Star Astrology",
    whatIsZiWei: "What is Purple Star Astrology?",
    requiredInfo: "Required Information",
    interpretation: "Interpretation",
    whatIsDescription: "Purple Star Astrology is an ancient Chinese astrology system that creates a chart based on a person's birth date and time. It analyzes the positions of celestial bodies to provide insights into personality, relationships, career, and life path.",
    requiredInfoDescription: "To create an accurate Purple Star Astrology chart, you'll need the person's exact birth date, time, and location. The more precise this information, the more accurate the chart will be.",
    interpretationDescription: "The chart analysis provides insights into various aspects of life including career, relationships, health, and personal development. The interpretation combines both traditional wisdom and modern psychological understanding."
  },

  form: {
    name: "Name",
    relationship: "Relationship",
    gender: "Gender",
    birthDate: "Birth Date",
    birthTime: "Birth Time",
    birthPlace: "Birth Place",
    saveProfile: "Save Profile",
    selectGender: "Select gender",
    male: "Male",
    female: "Female",
    namePlaceholder: "Person's name",
    relationshipPlaceholder: "e.g. Friend, Client, Father",
    birthPlacePlaceholder: "City, Country",
    yourNamePlaceholder: "Your name",
    theirNamePlaceholder: "Their name",
    cancel: "Cancel",
    createSelfProfile: "Create My Profile",
    createOtherProfile: "Create Profile",
    selectedDate: "Selected Date",
    selectTime: "Select Time",
    dateFormatHint: "Enter date in DD/MM/YYYY format (e.g., 31/12/1990)",
    invalidDateFormat: "Invalid date format. Please use DD/MM/YYYY",
    dontRememberBirthTime: "I don't remember my birth time",
    submitting: "Creating...",
    email: "Email Address",
    emailPlaceholder: "your@email.com",
  },
};

export default calculate;